import { render, staticRenderFns } from "./DaySummary.vue?vue&type=template&id=45f20a36&scoped=true"
import script from "./DaySummary.vue?vue&type=script&lang=js"
export * from "./DaySummary.vue?vue&type=script&lang=js"
import style0 from "./DaySummary.vue?vue&type=style&index=0&id=45f20a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f20a36",
  null
  
)

export default component.exports